import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { SITE_NAME } from "@/config/appConfig";

export default function AlreadyHaveAccountMessage({ email = "", subscribe }) {
  return (
    <div className="already-have-account-message">
      <h2 className="heading">Looks like you already have an account</h2>

      <h6 className="subheading">
        We couldn’t create a new {SITE_NAME} account because there’s already an
        account with your email address <strong>{email}</strong>.
      </h6>
      <h6 className="subheading">
        You can log in to this account – and reset the password if you need to –
        here:
      </h6>
      <div className="text-center mt-5">
        <Button
          component={Link}
          to={`/login?email=${email}${subscribe ? "&subscribe=true" : ""}`}
          variant="contained"
          color="primary"
          className="mx-auto"
          size="large"
        >
          Login
        </Button>
      </div>
    </div>
  );
}
